"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.CancelSubscriptionEvent = void 0;
const Name = exports.Name = 'cancel-subscription';
const CancelSubscriptionEvent = exports.CancelSubscriptionEvent = Name;
//# sourceMappingURL=index.js.map